import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme: { layout } }) => layout.spacing(6)};
  border-top: 1px solid ${({ theme: { colors } }) => colors.borderGray};
  padding: ${({ theme: { layout } }) => layout.spacing(2)};
  padding-right: ${({ theme: { layout } }) => layout.spacing(12)};
  background: ${({ theme: { colors } }) => colors.backgroundContent};
  font-size: ${({ theme: { fontSize } }) => fontSize.small};
  line-height: 24px;
`

export const Navigation = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { layout } }) => layout.spacing(1)};
`

export const Spacer = styled.span`
  width: ${({ theme: { layout } }) => layout.spacing(7)};
`

export type ButtonProps = {
  isDisabled: boolean
  onClick: () => void
}

export const Button = styled.span<ButtonProps>`
  display: block;
  cursor: pointer;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      color: ${({ theme: { colors } }) => colors.disabled};
      cursor: default;
    `}

  svg {
    display: block;
  }
`
